module.exports = __webpack_public_path__ + "assets/fonts/iconfont.af1177fa.woff";